
export enum InputTypes {
	Email = "email",
	Number = "number",
	Password = "password",
	Tel = "tel",
	Text = "text",
	Url = "url"
}
